export default __webpack_public_path__ + "4412077550a3d0ec6d36237156f889d8.png";